



















































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { statusSummaryMap } from '@/utils/finance';
import { getFinanceUsers, setProjectAuth, setFundAuth } from '@/api/finance.js';
import selectMember from '@/components/project/selectMember.vue';

interface User {
  id: number;
  nickname: string;
}
@Component({
  components: {
    selectMember
  }
})
class AuthConfig extends Vue {
  modifyUsers: User[] = [];
  queryUsers: User[] = [];
  statusSummaryMap = statusSummaryMap;
  @Prop()
  visible;

  @Prop()
  type;

  @Prop()
  project;

  created() {
    let {
      project: { financePeopleId, financePeopleName, queryUsers = [], financeUsers = [] },
      type
    } = this;

    // TODO 把financePeople字符串转成数组
    if (type === 'fund') {
      this.modifyUsers =
        financePeopleId && financePeopleName
          ? [
            {
              id: financePeopleId,
              nickname: financePeopleName
            }
          ]
          : [];
    } else {
      this.modifyUsers = financeUsers.map(item => ({
        id: item.userId,
        nickname: item.userName
      }));
    }
    this.queryUsers = queryUsers.map(item => ({
      id: item.userId,
      nickname: item.userName
    }));
  }

  handleCancel() {
    this.$emit('hide');
  }

  async handleOk() {
    try {
      // TODO 加人数判断
      if (this.modifyUsers.length <= 2) {
        let {
          project: { projectId, fundId },
          modifyUsers,
          queryUsers,
          type
        } = this;
        let res;
        if (type === 'fund') {
          res = await setFundAuth({
            fundId,
            modifyUserId: (modifyUsers[0] && modifyUsers[0].id) || null,
            queryUserIds: queryUsers.map(_ => _.id).join(',')
          });
        } else {
          // TODO 拼接成string
          res = await setProjectAuth({
            projectId,
            modifyUserIds: modifyUsers.map(_ => _.id).join(',') || null,
            queryUserIds: queryUsers.map(_ => _.id).join(',')
          });
        }

        if (res.code === 200) {
          this.$message.success('保存成功');
          this.$emit('hide');
          this.$emit('refresh');
        }
      } else {
        throw {
          message: '至多选择两个财务负责人'
        };
      }
    } catch (e) {
      this.$message.error(e.message);
    }
  }

  choseUserIds(members, parentIndex) {
    if (parentIndex === 0) {
      this.modifyUsers = members;
    } else {
      this.queryUsers = members;
    }
  }

  delUserIds(user, parentIndex) {
    if (parentIndex === 0) {
      this.modifyUsers = this.modifyUsers.filter(_user => _user.id !== user.id);
    } else {
      this.queryUsers = this.queryUsers.filter(_user => _user.id !== user.id);
    }
  }
}

export default AuthConfig;
